import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";
import { assetUrl } from "@/lib/api";

const ARTICLES = [
  {
    title: "Comment définir son budget travaux ?",
    img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85",
    slug: "definir-budget-travaux",
  },
  {
    title: "Bien préparer une rénovation",
    img: "https://images.pexels.com/photos/3214064/pexels-photo-3214064.jpeg?auto=compress&cs=tinysrgb&w=1080",
    slug: "preparer-renovation",
  },
  {
    title: "Comment choisir les bons professionnels ?",
    img: assetUrl("/api/static/redesign/conseil-pros.webp"),
  },
];

const soon = () => toast.info("Nos guides et conseils arrivent bientôt.");

export const Advice = () => (
  <section id="conseils" data-testid="advice-section" className="bg-ivory py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">
              Conseils
            </p>
            <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-navy sm:text-6xl">
              Les clés pour réussir <span className="italic text-sage">vos travaux.</span>
            </h2>
          </div>
          <Link
            data-testid="advice-more"
            to="/conseils"
            className="group flex items-center gap-2 rounded-full border border-navy/20 px-6 py-3 text-sm font-bold text-navy transition-colors duration-300 hover:border-navy hover:bg-navy hover:text-white"
          >
            Voir tous nos conseils
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {ARTICLES.map((a, i) => {
          const CardTag = a.slug ? Link : "button";
          const cardProps = a.slug ? { to: `/conseils/${a.slug}` } : { onClick: soon, type: "button" };
          return (
            <Reveal key={a.title} delay={i * 0.08}>
              <CardTag data-testid={`advice-card-${i}`} {...cardProps} className="group block w-full text-left">
                <div className="overflow-hidden rounded-3xl">
                  <img
                    src={a.img}
                    alt={a.title}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                </div>
                <div className="mt-5 flex items-start justify-between gap-4 px-1">
                  <h3 className="font-display text-2xl font-medium leading-snug text-navy transition-colors duration-300 group-hover:text-sage">
                    {a.title}
                  </h3>
                  <span className="mt-1 shrink-0 rounded-full border border-navy/15 p-2 text-navy transition-colors duration-300 group-hover:border-cognac group-hover:bg-cognac group-hover:text-white">
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
                  </span>
                </div>
              </CardTag>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
